import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import ProtectedRoute from './components/ProtectedRoute';
import { useAuth } from './context/AuthContext';

import Landing from './pages/Landing';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';

import AdminDashboard from './pages/admin/AdminDashboard';
import AdminUsers from './pages/admin/AdminUsers';
import AdminCourses from './pages/admin/AdminCourses';
import AdminEnrollments from './pages/admin/AdminEnrollments';
import AdminCertifications from './pages/admin/AdminCertifications';
import AdminCertificates from './pages/admin/AdminCertificates';

import UserDashboard from './pages/user/UserDashboard';
import BrowseCourses from './pages/user/BrowseCourses';
import MyCourses from './pages/user/MyCourses';
import MyCertificates from './pages/user/MyCertificates';

import TrainerDashboard from './pages/trainer/TrainerDashboard';
import TrainerCourses from './pages/trainer/TrainerCourses';
import TrainerStudents from './pages/trainer/TrainerStudents';
import TrainerCertificates from './pages/trainer/TrainerCertificates';

const Shell = ({ children }) => (
  <div className="app-shell">
    <Navbar />
    {children}
  </div>
);

// Redirect logged-in users away from auth pages
const RedirectIfAuth = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) {
    if (user.role === 'admin') return <Navigate to="/admin" replace />;
    if (user.role === 'trainer') return <Navigate to="/trainer" replace />;
    return <Navigate to="/dashboard" replace />;
  }
  return children;
};

export default function App() {
  return (
    <Routes>
      {/* Public */}
      <Route path="/" element={<Shell><Landing /></Shell>} />
      <Route path="/login" element={<RedirectIfAuth><Login /></RedirectIfAuth>} />
      <Route path="/register" element={<RedirectIfAuth><Register /></RedirectIfAuth>} />
      <Route path="/forgot-password" element={<RedirectIfAuth><ForgotPassword /></RedirectIfAuth>} />
      <Route path="/reset-password/:token" element={<RedirectIfAuth><ResetPassword /></RedirectIfAuth>} />

      {/* Admin routes */}
      <Route path="/admin" element={
        <ProtectedRoute roles={['admin']}><Shell><AdminDashboard /></Shell></ProtectedRoute>
      } />
      <Route path="/admin/users" element={
        <ProtectedRoute roles={['admin']}><Shell><AdminUsers /></Shell></ProtectedRoute>
      } />
      <Route path="/admin/courses" element={
        <ProtectedRoute roles={['admin']}><Shell><AdminCourses /></Shell></ProtectedRoute>
      } />
      <Route path="/admin/enrollments" element={
        <ProtectedRoute roles={['admin']}><Shell><AdminEnrollments /></Shell></ProtectedRoute>
      } />
      <Route path="/admin/certifications" element={
        <ProtectedRoute roles={['admin']}><Shell><AdminCertifications /></Shell></ProtectedRoute>
      } />
      <Route path="/admin/certificates" element={
        <ProtectedRoute roles={['admin']}><Shell><AdminCertificates /></Shell></ProtectedRoute>
      } />

      {/* User routes */}
      <Route path="/dashboard" element={
        <ProtectedRoute roles={['user']}><Shell><UserDashboard /></Shell></ProtectedRoute>
      } />
      <Route path="/courses" element={
        <ProtectedRoute roles={['user']}><Shell><BrowseCourses /></Shell></ProtectedRoute>
      } />
      <Route path="/my-courses" element={
        <ProtectedRoute roles={['user']}><Shell><MyCourses /></Shell></ProtectedRoute>
      } />
      <Route path="/my-certificates" element={
        <ProtectedRoute roles={['user']}><Shell><MyCertificates /></Shell></ProtectedRoute>
      } />

      {/* Trainer routes */}
      <Route path="/trainer" element={
        <ProtectedRoute roles={['trainer']}><Shell><TrainerDashboard /></Shell></ProtectedRoute>
      } />
      <Route path="/trainer/courses" element={
        <ProtectedRoute roles={['trainer']}><Shell><TrainerCourses /></Shell></ProtectedRoute>
      } />
      <Route path="/trainer/students" element={
        <ProtectedRoute roles={['trainer']}><Shell><TrainerStudents /></Shell></ProtectedRoute>
      } />
      <Route path="/trainer/certificates" element={
        <ProtectedRoute roles={['trainer']}><Shell><TrainerCertificates /></Shell></ProtectedRoute>
      } />

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
